import React from "react";
import { Row, Col, Tag, Divider, Empty, Button, message } from "antd";
import {
  BankOutlined,
  CalendarOutlined,
  CheckCircleOutlined,
  DollarOutlined,
  PrinterOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import THEME from "../theme";
import { formatMoney, formatDate } from "../utils";
import StyledCard from "../components/StyledCard";
import StatBox from "../components/StatBox";
import InfoItem from "../components/InfoItem";
import { exportCardDebtorOldPdf } from "../../export/CardDebtorOld";

const LoanInfoTab = ({ judgeData, loanData, remarkValueOld }) => {
  const loan = loanData?.LOAN;
  if (!loan) return <Empty description="ไม่มีข้อมูล" />;

  const handlePrint = async () => {
    try {
      await exportCardDebtorOldPdf({ loanData, judgeData, remarkValueOld });
    } catch (error) {
      console.error("exportCardDebtorOldPdf error:", error);
      message.error("เกิดข้อผิดพลาดในการสร้างเอกสาร");
    }
  };

  return (
    <StyledCard
      title="ข้อมูลสัญญา(เก่า)"
      icon={<BankOutlined style={{ color: THEME.primary, fontSize: 18 }} />}
      style={{ marginBottom: 16 }}
      extra={
        <Button
          type="primary"
          icon={<PrinterOutlined />}
          onClick={handlePrint}
          size="small"
          disabled={judgeData?.judge?.length > 0}
        >
          พิมพ์
        </Button>
      }
    >
      <Row gutter={[16, 16]}>
        <Col xs={12} sm={8} md={6}>
          <StatBox
            title="ยอดจัดทั้งหมด"
            value={loan?.TOTPRC}
            color={THEME.primary}
            icon={<DollarOutlined />}
          />
        </Col>
        <Col xs={12} sm={8} md={6}>
          <StatBox
            title="ยอดจัดไม่รวมดอก"
            value={loan?.NCSHPRC}
            color={THEME.info}
            icon={<BankOutlined />}
          />
        </Col>
        <Col xs={12} sm={8} md={6}>
          <StatBox
            title="ชำระแล้ว"
            value={loan?.SMPAY}
            color={THEME.success}
            icon={<CheckCircleOutlined />}
          />
        </Col>
        <Col xs={12} sm={8} md={6}>
          <StatBox
            title="ยอดค้างชำระ ≈"
            value={loan?.EXP_AMT}
            color={THEME.danger}
            icon={<WarningOutlined />}
          />
        </Col>
      </Row>
      <Divider style={{ margin: "20px 0" }} />
      <Row gutter={[32, 16]}>
        <Col xs={12} sm={8} md={4}>
          <InfoItem
            label="วันทำสัญญา"
            value={formatDate(loan?.SDATE)}
            icon={<CalendarOutlined />}
          />
        </Col>
        <Col xs={12} sm={8} md={4}>
          <InfoItem label="งวดแรก" value={formatDate(loan?.FDATE)} />
        </Col>
        <Col xs={12} sm={8} md={4}>
          <InfoItem label="งวดสุดท้าย" value={formatDate(loan?.LDATE)} />
        </Col>
        <Col xs={12} sm={8} md={4}>
          <InfoItem label="จำนวนงวด" value={`${loan?.T_NOPAY || 0} งวด`} />
        </Col>
        <Col xs={12} sm={8} md={4}>
          <InfoItem
            label="งวดละ"
            value={`${formatMoney(loan?.TOT_UPAY)} บาท`}
          />
        </Col>
        <Col xs={12} sm={8} md={4}>
          <InfoItem label="ชำระล่าสุด" value={formatDate(loan?.LPAYD)} />
        </Col>
        <Col xs={12} sm={8} md={4}>
          <InfoItem
            label="ยอดชำระล่าสุด"
            value={`${formatMoney(loan?.LPAYA)} บาท`}
          />
        </Col>
        <Col xs={12} sm={8} md={4}>
          <InfoItem
            label="ยอดค้างชำระ ≈"
            value={`${formatMoney(loan?.EXP_AMT)} บาท`}
          />
        </Col>
        <Col xs={12} sm={8} md={4}>
          <InfoItem
            label="ตั้งแต่"
            value={
              <Tag color={loan?.EXP_PRD > 3 ? "red" : "orange"}>
                ค้าง {loan?.EXP_PRD || 0} งวด ({loan?.EXP_FRM}-{loan?.EXP_TO})
              </Tag>
            }
          />
        </Col>
        <Col xs={12} sm={8} md={4}>
          <InfoItem
            label="ค่าอื่นๆค้างชำระ"
            value={`${formatMoney(loan?.PAYAMTAROTHR)} บาท`}
          />
        </Col>
        <Col xs={12} sm={8} md={4}>
          <InfoItem label="สัญญาเก่าคือ" value={`${loan?.ISSUNO || "-"}`} />
        </Col>
        <Col xs={12} sm={8} md={4}>
          <InfoItem
            label="สัญญาใหม่"
            value={`${judgeData?.loanNew?.NEWCONTNO || "-"}`}
          />
        </Col>
      </Row>
    </StyledCard>
  );
};

export default LoanInfoTab;
